import React from 'react'

interface CalendarIconProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const CalendarIcon: React.FC<CalendarIconProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			onClick={onClick}
			style={{
				cursor: onClick ? 'pointer' : 'default',
				...style,
			}}
		>
			<rect
				x='4'
				y='6'
				width='16'
				height='14'
				rx='2'
				stroke={color}
				strokeWidth='2'
			/>
			<path d='M8 4V8' stroke={color} strokeWidth='2' strokeLinecap='round' />
			<path d='M16 4V8' stroke={color} strokeWidth='2' strokeLinecap='round' />
			<path d='M8 16H16' stroke={color} strokeWidth='2' strokeLinecap='round' />
		</svg>
	)
}

export default CalendarIcon
